import { useState, type FormEvent } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/auth'

export function NouveauChantier({ fermer, cree }: { fermer: () => void; cree: () => void }) {
  const { profil } = useAuth()
  const [numero, setNumero] = useState('')
  const [nom, setNom] = useState('')
  const [adresse, setAdresse] = useState('')
  const [client, setClient] = useState('')
  const [eg, setEg] = useState('')
  const [erreur, setErreur] = useState<string | null>(null)
  const [occupe, setOccupe] = useState(false)

  async function envoyer(e: FormEvent) {
    e.preventDefault()
    setErreur(null)
    setOccupe(true)
    try {
      const { data, error } = await supabase
        .from('chantiers')
        .insert({
          numero: numero.trim(),
          nom: nom.trim(),
          adresse: adresse.trim() || null,
          client: client.trim() || null,
          entrepreneur_general: eg.trim() || null,
          cree_par: profil?.id ?? null
        })
        .select('id')
        .single()
      if (error) throw error

      // Le créateur est assigné d'office : sinon un administrateur crée un
      // chantier qu'il ne verrait pas dans sa propre liste.
      if (data && profil) {
        await supabase
          .from('chantier_membres')
          .insert({ chantier_id: data.id, profil_id: profil.id, assigne_par: profil.id })
      }
      cree()
    } catch (err) {
      const brut = err instanceof Error ? err.message : String(err)
      setErreur(
        /duplicate key/i.test(brut) ? 'Ce numéro de chantier existe déjà.' : brut
      )
    } finally {
      setOccupe(false)
    }
  }

  return (
    <div className="app">
      <header className="entete">
        <div className="entete-rang">
          <button className="retour" onClick={fermer}>
            ‹ Chantiers
          </button>
          <div>
            <h1>Nouveau chantier</h1>
          </div>
        </div>
      </header>

      <div className="corps">
        <form onSubmit={envoyer}>
          <label className="champ">
            <span>Numéro *</span>
            <input
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
              placeholder="C-2431"
              required
            />
          </label>
          <label className="champ">
            <span>Nom du chantier *</span>
            <input value={nom} onChange={(e) => setNom(e.target.value)} required />
          </label>
          <label className="champ">
            <span>Adresse</span>
            <input value={adresse} onChange={(e) => setAdresse(e.target.value)} />
          </label>
          <label className="champ">
            <span>Client</span>
            <input value={client} onChange={(e) => setClient(e.target.value)} />
          </label>
          <label className="champ">
            <span>Entrepreneur général</span>
            <input value={eg} onChange={(e) => setEg(e.target.value)} />
          </label>

          {erreur && (
            <p className="avis erreur" style={{ marginBottom: 12 }}>
              {erreur}
            </p>
          )}

          <button className="bouton" disabled={occupe}>
            {occupe ? 'Création…' : 'Créer le chantier'}
          </button>
        </form>
      </div>
    </div>
  )
}
